import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentCode24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDocumentCode24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 20.5h10a1.5 1.5 0 0 0 1.5-1.5v-8.5h-6.49v-7H7A1.5 1.5 0 0 0 5.5 5v14A1.5 1.5 0 0 0 7 20.5M18.347 8.645a.5.5 0 0 1 .153.354h-4.99V3.995zM14.18 2.558l5.205 5.006A2 2 0 0 1 20 9.005V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h5.794a2 2 0 0 1 1.387.558M7.4 11.17a.75.75 0 0 1 1.06 0l2.992 2.991.53.53-.53.53-2.992 2.993a.75.75 0 0 1-1.06-1.061l2.461-2.461L7.4 12.23a.75.75 0 0 1 0-1.06m4.338 6.58a.75.75 0 0 1 .75-.75h3.577a.75.75 0 0 1 0 1.5h-3.577a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentCode24);
